import * as types from './types'

export default {
  [types.NEW_FRANCHISE_MANUAL_SIDEBAR]: state => {
    return state.newFranchiseManualSidebar
  },
  [types.PUBLISH_MANUAL_VERSION_SIDEBAR]: state => {
    return state.publishManualVersionSidebar
  },
  [types.FRANCHISE_MANUALS_SEARCH_RESULT]: state => {
    return state.franchiseManualsSearchResult
  },
  [types.MY_FRANCHISE_MANUAL_CYCLE]: state => {
    return state.myFranchiseManualCycle
  },
  [types.MY_OPTIONAL_FRANCHISE_MANUAL_CYCLE]: state => {
    return state.myOptionalFranchiseManualCycle
  },
}
